<template>
  <div>
    <app-breadcrumb>
      <template #contentright>
        <b-button variant="primary"
          :to="{ name: 'workflow-create' }">
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
      </template>
    </app-breadcrumb>
    <validation-observer ref="workflowForm">
      <b-form class="workflowForm"
        ref="formWorkflow"
        @submit.prevent=""
        @reset.prevent="resetForm">
        <div class="row justify-content-center">
          <div class="col-12 col-md-7">
            <div class="card">
              <div class="card-body">
                <validation-provider #default="validationContext"
                  name="Tên luồng xử lý"
                  rules="required">
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder pb-0">Tên luồng xử lý <span class="text-danger">*</span></label>
                    </template>
                    <b-form-input type="text"
                      id="name"
                      v-model="frmData.name"
                      :state="getValidationState(validationContext)"
                      placeholder="Nhập..." />
                    <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <validation-provider #default="validationContext"
                  vid="workflow_transition_id"
                  name="Trạng thái chuyển đổi"
                  rules="required">
                  <b-form-group>
                    <template #label>
                      <label class="d-block font-weight-bolder pb-0">Trạng thái chuyển đổi <span class="text-danger">*</span></label>
                    </template>
                    <v-select v-model="frmData.workflow_transition_id"
                      :options="dataListState"
                      label="name"
                      :reduce="(val) => val.id"
                      placeholder="--Chọn--"
                      multiple
                      :state="getValidationState(validationContext)" />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)"> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <b-form-group label="Mô tả"
                  label-for="textarea">
                  <b-form-input type="text"
                    id="textarea"
                    v-model="frmData.desc"
                    placeholder="Nhập mô tả..." />
                </b-form-group>
                <b-form-checkbox v-model="frmData.status"
                  value="1"
                  class="custom-control-primary"> Kích hoạt </b-form-checkbox>
                <div class="d-flex mt-2">
                  <b-button variant="primary"
                    type="submit"
                    @click.prevent="validationForm"> {{ $t('Save') }} </b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-5"
            style="display: none">
            <div class="card">
              <div class="card-body">
                <b-form-group label="Nhóm người dùng"
                  v-slot="{ ariaDescribedby }">
                  <b-form-checkbox-group id="group_id"
                    v-model="frmData.group_id"
                    :options="dataGroup"
                    value-field="id"
                    text-field="name"
                    stacked
                    :aria-describedby="ariaDescribedby" />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { required, email, alphaNum, min, max, } from '@validations'
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import { showToast, useRouter } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import vSelect from 'vue-select'
export default {

  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    Ripple,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    AppBreadcrumb,
    BFormCheckboxGroup,
    vSelect
  },
  directives: {
    Ripple,
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const workflow_id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const dataListState = ref([])
    const dataGroup = ref([]);

    const blankData = {
      id: '',
      name: '',
      desc: '',
      workflow_transition_id: [],
      group_id: [],
      status: 0
    }
    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)

    const fetchDataListState = () => {
      store.dispatch('workflowTransition/fetchAll', { type: 'all' })
        .then(response => {
          if (response.data.code === 200) {
            dataListState.value = response.data.data
          }
        })
    }
    fetchDataListState();

    const fetchData = () => {
      store.dispatch('workflow/show', { id: workflow_id.value })
        .then(response => {
          if (response.status === 200) {
            frmData.value = response.data.data
          }
        })
    }
    const fetchGroup = () => {
      store.dispatch('groups/fetchGroups')
        .then(response => {
          let result = response.data;
          if (result.code == 200) {
            dataGroup.value = result.data
          }

        })
    }
    fetchGroup()
    if (workflow_id.value) {
      fetchData();
    }
    watch(
      () => context.root.$route,
      (to) => {
        if (to.name === 'workflow-create') {
          resetfrmData();
        } else {
          fetchData();
        }
      },
    )

    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
      dataListState,
      dataGroup
    }
  },
  methods: {
    onSubmit() {
      let workflow_id = this.frmData.id;
      if (workflow_id) {
        store.dispatch('workflow/update', { data: this.frmData, id: workflow_id })
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$router.push({ name: 'workflow-list' });
            } else {
              if (result.errors) {
                this.errorMessage = result.errors;
              } else {
                showToast(result.message);
              }
            }
          })
      } else {
        store.dispatch('workflow/create', this.frmData)
          .then(response => {
            const result = response.data;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.resetfrmData()
              this.$router.push({ name: 'workflow-list' });
            } else {
              if (result.errors) {
                this.errorMessage = result.errors;
              } else {
                showToast(result.message);
              }
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.workflowForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  }
}
</script>
<style lang="scss">
.col-form-label {
  font-size: 1.1rem;
  font-weight: bold
}

.custom-control-label {
  cursor: pointer;
}

.custom-control.custom-checkbox {
  padding-bottom: 0.5rem;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>